import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useRouteError } from "react-router-dom";
import { Constants } from "../../utils/constants/Constants";

const ErrorElement = () => {
  let error = useRouteError();
  console.log(error);
  return (
    <Box
      width={"100%"}
      height={"100vh"}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      gap={"20px"}
    >
      <Typography variant="h2">{Constants.ERROR_MESSAGE}</Typography>

      <Button
        onClick={() => window.location.reload()}
        variant="outlined"
        size="large"
      >
        Retry
      </Button>
    </Box>
  );
};

export default ErrorElement;
